// Style for an absolutely positioned grid layer that fades out in soft circular patches.
// `gaps` are [x%, y%, clearRadiusPx, fadeRadiusPx]; each one punches a hole, and
// intersecting the masks keeps every hole. The grid also fades toward the panel edges,
// and a slight blur softens the 1px lines so they don't read as hard strokes.
const EDGE_FADE = 'radial-gradient(ellipse 75% 85% at 50% 50%, #000 45%, transparent 100%)';

// `extraMasks` are additional mask layers (e.g. a vertical fade) intersected with the rest
export const gridOverlayStyle = ({ color, size, gaps, edgeFade = true, extraMasks = [] }) => {
    const mask = [
        ...(edgeFade ? [EDGE_FADE] : []),
        ...extraMasks,
        ...gaps.map(([x, y, clear, fade]) => `radial-gradient(circle at ${x}% ${y}%, transparent 0 ${clear}px, #000 ${fade}px)`),
    ].join(', ');
    return {
        backgroundImage: `linear-gradient(${color} 1px, transparent 1px), linear-gradient(90deg, ${color} 1px, transparent 1px)`,
        backgroundSize: `${size}px ${size}px`,
        filter: 'blur(0.6px)',
        maskImage: mask,
        WebkitMaskImage: mask,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
    };
};
